export const config = {
    // API Configuration
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000',

    // Development mode
    devMode: import.meta.env.VITE_DEV_MODE === 'true',
    devTelegramId: import.meta.env.VITE_DEV_TELEGRAM_ID || '123456789',

    // Polling configuration
    queuePollingInterval: 2000, // 2 seconds

    // Retry configuration
    maxRetries: 3,
    retryDelay: 1000, // 1 second

    // Game configuration
    chatDuration: 60, // 60 seconds mock timer
};
